import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "toggleIcon"]
  static values = { secret: String }

  connect() {
    this.visible = false
  }

  toggle() {
    this.visible = !this.visible
    this.displayTarget.textContent = this.visible ? this.secretValue : this.maskedValue()
    this.toggleIconTarget.textContent = this.visible ? "visibility_off" : "visibility"
  }

  maskedValue() {
    return "\u2022\u2022\u2022\u2022 - \u2022\u2022\u2022\u2022"
  }
}
